// extracted by mini-css-extract-plugin
module.exports = {"login_page_holder":"Login_login_page_holder__m5LIE","form_holder":"Login_form_holder__oc0ec","input_field":"Login_input_field__UOV29","error_alert":"Login_error_alert__HI7Df"};